import React, { createContext, useContext } from "react";
import { useToaster, Message } from "rsuite";
import "../components/Toaster.css";

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const toaster = useToaster();

  const addToast = (type, message, header) => {
    toaster.push(
      <Message showIcon type={type} header={header} closable>
        {message}
      </Message>,
      { placement: "topEnd", duration: 10000 }
    );
  };

  const success = (message, header) => {
    addToast("success", message, header);
  };

  const warning = (message, header) => {
    addToast("warning", message, header);
  };

  const info = (message, header) => {
    addToast("info", message, header);
  };

  const error = (message, header) => {
    addToast("error", message, header);
  };

  const value = { success, warning, info, error };

  return (
    <ToastContext.Provider value={value}>{children}</ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
